export class TakeSnapshotRequest {
    'vaultId';
    'retentionDays';
    'isPitrOnDemand';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": ""
        },
        {
            "name": "retentionDays",
            "baseName": "retentionDays",
            "type": "number",
            "format": ""
        },
        {
            "name": "isPitrOnDemand",
            "baseName": "isPitrOnDemand",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TakeSnapshotRequest.attributeTypeMap;
    }
    constructor() {
    }
}
